<template>
	<div
		id="app"
		class="font-body text-base text-primary"
		v-bind:class="{ appTop: auth }"
	>
		<Loader v-if="isLoading" />
		<Header class="header" v-if="auth" />
		<transition class="content" name="fade">
			<router-view />
		</transition>
	</div>
</template>

<script>
import Header from '@/components/Header.vue'
import { mapGetters } from 'vuex'
import Loader from '@/components/Loader.vue'

export default {
	components: {
		Header,
		Loader
	},
	computed: {
		...mapGetters({
			auth: 'login/auth',
			isLoading: 'isLoading',
			user: 'login/user'
		})
	},
	updated() {
		this.switchLang()
	},
	methods: {
		switchLang() {
			const languages = ['es', 'pt', 'it']
			if (navigator.language.includes('es')) {
				this.$i18n.locale = 'es'
			} else if (navigator.language.includes('pt')) {
				this.$i18n.locale = 'pt'
			} else if (navigator.language.includes('it')) {
				this.$i18n.locale = 'it'
			} else {
				this.$i18n.locale = 'es'
			}

			if (this.user) {
				this.$i18n.locale = languages[this.user.country_id - 1]
			}
		}
	}
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
	transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
	opacity: 0;
}
.header {
	position: fixed;
	top: 0;
	z-index: 100;
}
.appTop {
	padding-top: 115px;
}
@media (max-width: 768px) {
	.appTop {
		padding-top: 65px;
	}
}
</style>
